export const defaultConfirmationPaneSubtitleStyles = {
  color: "#605e5c",
  fontFamily: "Segoe UI, Arial, sans-serif",
  fontSize: "14px",
  fontWeight: "400",
  margin: "14px 0px",
  width: "100%",
  textAlign: "center"
};